import DevCycleProvider from './DevCycleProvider'
export default DevCycleProvider
